import React, { useState } from 'react';
import { Container, Typography, Box } from '@mui/material';
import { Link } from 'react-router-dom';
import './Support.scss';

const faqs = [
    {
        q: 'What is Relayr?',
        a: 'Relayr is a mobile chat platform that lets you join networks, participate in channels, and have real-time conversations with communities that share your interests.',
    },
    {
        q: 'Is Relayr free to use?',
        a: 'Yes, Relayr is free to download and use. Some premium features may be offered in the future through in-app subscriptions.',
    },
    {
        q: 'How do I join a network?',
        a: 'Tap the "Discover" icon to browse available networks. You can search by name or filter by category (Tech, Gaming, Art & Design, etc.). Tap "Join" on any network to become a member.',
    },
    {
        q: 'Can I create my own network?',
        a: 'Yes! Tap the "+" button on the Networks screen to create a new network. You can set it as public or private, add channels, and invite members.',
    },
    {
        q: 'What are channels?',
        a: 'Channels are topic-based conversations within a network. For example, a tech network might have channels for #javascript, #python, #career-advice, and more.',
    },
    {
        q: 'How do mentions and replies work?',
        a: 'You can mention other users with @ in any channel. Tap on a message to reply directly and create a threaded conversation.',
    },
    {
        q: 'How do I manage notifications?',
        a: 'You can control notifications per network and per channel. Go to a network\'s settings to choose between All Activity, Mentions Only, or Muted.',
    },
    {
        q: 'How do I report inappropriate content?',
        a: 'Tap and hold on any message to see options, then select "Report". Our moderation team reviews all reports and takes action as needed.',
    },
    {
        q: 'How do I delete my account?',
        a: 'You can delete your account from the Profile tab in the app, or by contacting us at support@relayr.app. All associated data will be permanently removed.',
    },
    {
        q: 'Is my data secure?',
        a: 'Yes. We use industry-standard encryption and secure cloud infrastructure to protect your data. We never sell your personal information. See our Privacy Policy for full details.',
    },
];

const FAQItem = ({ q, a }) => {
    const [open, setOpen] = useState(false);

    return (
        <div className="faq-item">
            <div
                className={`faq-question ${open ? 'open' : ''}`}
                onClick={() => setOpen(!open)}
            >
                {q}
                <span className="faq-toggle">+</span>
            </div>
            {open && (
                <div className="faq-answer">{a}</div>
            )}
        </div>
    );
};

const Support = () => (
    <div className="relayr-support">
        <header className="support-header">
            <Container maxWidth="md">
                <Link to="/relayr" className="support-back">&larr; Back to Relayr</Link>
                <span className="support-badge">Relayr</span>
                <Typography variant="h4" sx={{ color: '#fff', fontWeight: 700 }}>
                    Support
                </Typography>
            </Container>
        </header>

        <Container maxWidth="md" className="support-content">
            {/* FAQ */}
            <section className="faq-section">
                <Typography variant="h5" className="faq-title">
                    Frequently Asked Questions
                </Typography>
                {faqs.map((faq, i) => (
                    <FAQItem key={i} q={faq.q} a={faq.a} />
                ))}
            </section>

            {/* Contact */}
            <section className="contact-section">
                <Typography variant="h5" className="contact-title">
                    Still Need Help?
                </Typography>
                <Typography className="contact-desc">
                    We're here to help. Reach out with any questions, feedback, or issues.
                </Typography>
                <a href="mailto:support@relayr.app" className="contact-email">
                    support@relayr.app
                </a>
            </section>

            {/* Footer links */}
            <Box className="support-footer">
                <Link to="/relayr">Home</Link>
                <Link to="/relayr/privacy">Privacy Policy</Link>
                <Link to="/relayr/terms">Terms of Service</Link>
            </Box>
        </Container>
    </div>
);

export default Support;
